import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../stores/CurrentUserStore'
import { PermissionNames } from '@getgreenline/homi-shared'
import { NoPermissionsResult } from '../../../../components/NoPermissionsResult'
import { ShiftsV2 } from './V2/ShiftsV2'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  currentUserStore: CurrentUserStore
}

export const ShiftsPage: React.FC<Props> = inject(
  'currentCompanyStore',
  'currentUserStore',
)(
  observer(({ currentUserStore, currentCompanyStore }) => {
    const company = currentCompanyStore.company
    if (!company) {
      return null
    }

    if (!currentUserStore.hasPermissionAtEntity(PermissionNames.CAN_VIEW_REPORTS, company.id)) {
      return <NoPermissionsResult permissionName={PermissionNames.CAN_VIEW_REPORTS} />
    }

    return <ShiftsV2 />
  }),
)
